<template>
	<div class="contentbox">
		<div v-if="platform == 'wx-sv' || platform == 'wx-gg-sv' ">
			<span>回传平台</span>
			<el-radio-group v-model="returnPlatform" @input="handleReturnPlatform" class="return-platform">
				<el-radio :label="1">巨量回传</el-radio>
				<el-radio :label="2">腾讯广点通回传</el-radio>
			</el-radio-group>
		</div>
		<div v-if="platform == 'dy-sv' || platform == 'dy-dp'">
			<span>回传类型</span>
			<el-radio-group v-model="formInline.type" @input="handleReturnType" class="return-platform">
				<el-radio :label="1">免费回传</el-radio>
				<el-radio :label="2">付费回传</el-radio>
			</el-radio-group>
		</div>
		<el-divider></el-divider>
		<div class="media-add-ep-list">
			<div class="top-search">
				<el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
					<el-form-item label="方案名" prop="title">
						<el-input type="text" v-model="formInline.title" placeholder="请输入方案名" clearable @keyup.enter.native="search"
							@clear="search" style="width: 180px;"></el-input>
					</el-form-item>
					<el-form-item label="回传类型" prop="type" style="margin-right: 30px;" v-if="platform == 'wx-sv' || platform == 'wx-gg-sv' ">
						<el-select v-model="formInline.type" placeholder="请选择回传类型" clearable @change="search" style="width: 180px;">
							<el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
					</el-form-item>
					<br />
					<el-form-item>
						<el-button type="success" icon="el-icon-circle-plus-outline" @click="addData">添加</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tableTh" v-height>
				<!-- 巨量列表 -->
				<el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle"
					v-loading="loading" v-if="returnPlatform == 1">
					<el-table-column prop="" label="序号" width="60">
						<template slot-scope="scope">
							<span>{{ (tableData.pageNo - 1) * tableData.pageSize + scope.$index + 1 }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="方案名" width="160">
					</el-table-column>
					<el-table-column label="回传类型" width="160">
						<template slot-scope="scope">
							<span v-if="scope.row.type == 1">免费回传</span>
							<span v-if="scope.row.type == 2">付费回传</span>
						</template>
					</el-table-column>
					<el-table-column label="回传状态" width="160" v-if="formInline.type == 1">
						<template slot-scope="scope">
							<span v-if="scope.row.status == 1">广告回传</span>
							<span v-if="scope.row.status == 2">按人回传</span>
						</template>
					</el-table-column>
					<el-table-column label="回传方式" width="160">
						<template slot-scope="scope">
							<span v-if="scope.row.way == 1">关键行为</span>
							<span v-if="scope.row.way == 2">付费</span>
						</template>
					</el-table-column>
					<el-table-column label="回传配置" width="160" v-if="formInline.type == 2">
						<template slot-scope="scope">
							<span v-if="scope.row.postbakSet == 1">全部回传配置</span>
							<span v-if="scope.row.postbakSet == 2">自定义回传配置</span>
						</template>
					</el-table-column>
					<el-table-column label="回传条件" v-if="formInline.type == 1">
						<template slot-scope="scope">
							<div class="td-info">
								<p>条件：</p>
								<p>广告播放≥{{ scope.row.adNumber }}</p>
								<p>
									<span v-if="scope.row.relation == 1">且</span>
									<span v-if="scope.row.relation == 2">或</span>
								</p>
								<p>
									<span v-if="scope.row.ecpmType == 1">ECPM≥{{ scope.row.ecpmNumber }}</span>
									<span v-if="scope.row.ecpmType == 2">ECPM≤{{ scope.row.ecpmNumber }}</span>
									<span v-if="scope.row.ecpmType == 3">{{ scope.row.ecpmNumber }}≤ECPM≤{{ scope.row.ecpmAfterNumber
										}}</span>
								</p>
								<P>
									<span v-if="scope.row.arpuType == 1">ARPU≥{{ scope.row.arpuNumber }}</span>
									<span v-if="scope.row.arpuType == 2">ARPU≤{{ scope.row.arpuNumber }}</span>
									<span v-if="scope.row.arpuType == 3">{{ scope.row.arpuNumber }}≤ARPU≤{{ scope.row.arpuAfterNumber
										}}</span>
								</P>
								<p>回传设置：</p>
								<p>
									<span style="margin-right: 10px;">{{ scope.row.postbakSet == 2 ? '自定义回传' : '全部回传' }}</span>
									<span v-if="scope.row.postbakSet == 2">传{{ scope.row.conveyNumber }}漏{{ scope.row.omitNumber }}</span>
								</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="回传规则" v-if="formInline.type == 2">
						<template slot-scope="scope">
							<div class="td-info">
								<p v-if="scope.row.postbakSet == 1">
									<span v-if="scope.row.payBackWay == 1">回传用户所有充值</span>
									<span v-if="scope.row.payBackWay == 2">回传用户当天自然日所有充值</span>
									<span v-if="scope.row.payBackWay == 3">回传用户24小时内所有充值</span>
									<span v-if="scope.row.payBackWay == 4">回传用户首充</span>
									<span v-if="scope.row.payBackWay == 5">回传用户当天自然日首充</span>
									<span v-if="scope.row.payBackWay == 6">回传用户24小时内首充</span>
									<span v-if="scope.row.payBackWay == 7">回传用户在X小时内首次充值金额大于Y后的所有充值（含首次充值）</span>
									<span v-if="scope.row.payBackWay == 8">回传用户在X小时内单笔充值金额大于Y的首充</span>
								</p>
								<div v-if="scope.row.postbakSet == 2">
									<p>回传维度：
										<span v-if="scope.row.havePlan == 0">按链接回传</span>
										<span v-if="scope.row.havePlan == 1">按计划回传</span>
									</p>
									<p>回传保护数：
										<span>{{ scope.row.havePlanNumber }}</span>
									</p>
									<p>回传时间：
										<span v-if="scope.row.havePlanTime == 1">开启</span>
										<span v-if="scope.row.havePlanTime == 0">关闭</span>
									</p>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="350">
						<template slot-scope="scope" class="ddd">
							<el-button type="defult" icon="el-icon-warning-outline" size="mini"
								@click="handleLook(scope.row.id)">详情</el-button>
							<el-button type="primary" icon="el-icon-edit" size="mini" @click="handleEdit(scope.row.id)">编辑</el-button>
						</template>
					</el-table-column>
				</el-table>
				<!-- 腾讯列表 -->
				<el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle"
					v-loading="loading" v-if="returnPlatform == 2">
					<el-table-column prop="" label="序号" width="60">
						<template slot-scope="scope">
							<span>{{ (tableData.pageNo - 1) * tableData.pageSize + scope.$index + 1 }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="方案名" width="160">
					</el-table-column>
					<el-table-column label="回传类型" width="160">
						<template slot-scope="scope">
							<span v-if="scope.row.type == 3">免费回传</span>
							<span v-if="scope.row.type == 4">付费回传</span>
						</template>
					</el-table-column>
					<el-table-column label="投放目标" width="160">
						<template slot-scope="scope">
							<span v-if="scope.row.way == 1">关键行为</span>
							<span v-if="scope.row.way == 2">付费</span>
							<span v-if="scope.row.way == 3">注册</span>
						</template>
					</el-table-column>
					<el-table-column label="回传条件" v-if="formInline.type == 3">
						<template slot-scope="scope">
							<div class="td-info">
								<p>条件一：</p>
								<p>点击时长≥{{ scope.row.conditionTime }}秒</p>
								<p>
									<span v-if="scope.row.firstCondition == 1">且</span>
									<span v-if="scope.row.firstCondition == 2">或</span>
								</p>
								<p>条件二：</p>
								<p>
									广告播放次数≥{{ scope.row.adPlay }}次&nbsp;&nbsp;
									<span v-if="scope.row.secondCondition == 1">且</span>
									<span v-if="scope.row.secondCondition == 2">或</span>&nbsp;&nbsp;
									浏览集数≥{{ scope.row.epPlay }}集
								</p>
								<p>回传设置：</p>
								<p>
									<span style="margin-right: 10px;">{{ scope.row.postbakSet == 2 ? '自定义回传' : '全部回传' }}</span>
									<span v-if="scope.row.postbakSet == 2">传{{ scope.row.conveyNumber }}漏{{ scope.row.omitNumber }}</span>
								</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="回传配置" width="160" v-if="formInline.type == 4">
						<template slot-scope="scope">
							<span v-if="scope.row.postbakSet == 1">全部回传配置</span>
							<span v-if="scope.row.postbakSet == 2">自定义回传配置</span>
						</template>
					</el-table-column>
					<el-table-column label="回传规则" v-if="formInline.type == 4">
						<template slot-scope="scope">
							<div class="td-info">
								<p v-if="scope.row.postbakSet == 1">
									<span v-if="scope.row.payBackWay == 1">回传用户所有充值</span>
									<span v-if="scope.row.payBackWay == 2">回传用户当天自然日所有充值</span>
									<span v-if="scope.row.payBackWay == 3">回传用户24小时内所有充值</span>
									<span v-if="scope.row.payBackWay == 4">回传用户首充</span>
									<span v-if="scope.row.payBackWay == 5">回传用户当天自然日首充</span>
									<span v-if="scope.row.payBackWay == 6">回传用户24小时内首充</span>
									<span v-if="scope.row.payBackWay == 7">回传用户在X小时内首次充值金额大于Y后的所有充值（含首次充值）</span>
									<span v-if="scope.row.payBackWay == 8">回传用户在X小时内单笔充值金额大于Y的首充</span>
								</p>
								<div v-if="scope.row.postbakSet == 2">
									<p>回传维度：
										<span v-if="scope.row.havePlan == 0">按链接回传</span>
										<span v-if="scope.row.havePlan == 1">按计划回传</span>
									</p>
									<p>回传保护数：
										<span>{{ scope.row.havePlanNumber }}</span>
									</p>
									<p>回传时间：
										<span v-if="scope.row.havePlanTime == 1">开启</span>
										<span v-if="scope.row.havePlanTime == 0">关闭</span>
									</p>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="350">
						<template slot-scope="scope" class="ddd">
							<el-button type="defult" icon="el-icon-warning-outline" size="mini"
								@click="handleLook(scope.row.id)">详情</el-button>
							<el-button type="primary" icon="el-icon-edit" size="mini" @click="handleEdit(scope.row.id)">编辑</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<!--<el-pagination @current-change="handleCurrentChange" :page-size="tableData.pageSize"-->
					<!--background :current-page="currentPage" :total="tableData.totalNum">-->
					<!--</el-pagination>-->
					<el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
						:page-sizes="[20, 50, 100, 200, 500]" :page-size="tableData.pageSize" background :current-page="currentPage"
						layout="sizes, prev, pager, next, jumper, ->, total" :total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>
		</div>
		<!--详情-->
		<el-dialog title="详情" :visible.sync="dialogInfoVisible" center width="800px">
			<!-- 巨量详情 -->
			<table class="el-table el-table--border el-table--enable-row-hover mytable" cellspacing="0" cellpadding="0" v-if="returnPlatform == 1">
				<tbody>
					<tr>
						<td width="200">方案名</td>
						<td>
							<p>{{ rowForm.title }}</p>
						</td>
					</tr>
					<tr>
						<td>回传类型</td>
						<td>
							<span v-if="rowForm.type == 1">免费回传</span>
							<span v-if="rowForm.type == 2">付费回传</span>
						</td>
					</tr>
					<tr>
						<td>{{ formInline.type == 1 ? '回传状态' : '回传配置' }}</td>
						<td v-if="formInline.type == 1">
							<span v-if="rowForm.status == 1">广告回传</span>
							<span v-if="rowForm.status == 2">按人回传</span>
						</td>
						<td v-if="formInline.type == 2">
							<span v-if="rowForm.postbakSet == 1">全部回传配置</span>
							<span v-if="rowForm.postbakSet == 2">自定义回传配置</span>
						</td>
					</tr>
					<tr>
						<td>回传方式</td>
						<td>
							<span v-if="rowForm.way == 1">关键行为</span>
							<span v-if="rowForm.way == 2">付费</span>
						</td>
					</tr>
					<tr>
						<td>{{ formInline.type == 1 ? '回传条件' : '回传规则' }}</td>
						<td>
							<div v-if="formInline.type == 1">
								<p>条件：</p>
								<p>广告播放≥{{ rowForm.adNumber }}</p>
								<p>
									<span v-if="rowForm.relation == 1">且</span>
									<span v-if="rowForm.relation == 2">或</span>
								</p>
								<p>
									<span v-if="rowForm.ecpmType == 1">ECPM≥{{ rowForm.ecpmNumber }}</span>
									<span v-if="rowForm.ecpmType == 2">ECPM≤{{ rowForm.ecpmNumber }}</span>
									<span v-if="rowForm.ecpmType == 3">{{ rowForm.ecpmNumber }}≤ECPM≤{{ rowForm.ecpmAfterNumber }}</span>
								</p>
								<P>
									<span v-if="rowForm.arpuType == 1">ARPU≥{{ rowForm.arpuNumber }}</span>
									<span v-if="rowForm.arpuType == 2">ARPU≤{{ rowForm.arpuNumber }}</span>
									<span v-if="rowForm.arpuType == 3">{{ rowForm.arpuNumber }}≤ARPU≤{{ rowForm.arpuAfterNumber }}</span>
								</P>
								<p>回传设置：</p>
								<p>
									<span style="margin-right: 10px;">{{ rowForm.postbakSet == 2 ? '自定义回传' : '全部回传' }}</span>
									<span v-if="rowForm.postbakSet == 2">传{{ rowForm.conveyNumber }}漏{{ rowForm.omitNumber }}</span>
								</p>
							</div>
							<div v-if="formInline.type == 2">
								<p v-if="rowForm.postbakSet == 1">
									<span v-if="rowForm.payBackWay == 1">回传用户所有充值</span>
									<span v-if="rowForm.payBackWay == 2">回传用户当天自然日所有充值</span>
									<span v-if="rowForm.payBackWay == 3">回传用户24小时内所有充值</span>
									<span v-if="rowForm.payBackWay == 4">回传用户首充</span>
									<span v-if="rowForm.payBackWay == 5">回传用户当天自然日首充</span>
									<span v-if="rowForm.payBackWay == 6">回传用户24小时内首充</span>
									<span v-if="rowForm.payBackWay == 7">回传用户在X小时内首次充值金额大于Y后的所有充值（含首次充值）</span>
									<span v-if="rowForm.payBackWay == 8">回传用户在X小时内单笔充值金额大于Y的首充</span>
								</p>
								<div v-if="rowForm.postbakSet == 2">
									<p>回传维度：
										<span v-if="rowForm.havePlan == 0">按链接回传</span>
										<span v-if="rowForm.havePlan == 1">按计划回传</span>
									</p>
									<p>回传保护数：
										<span>{{ rowForm.havePlanNumber }}</span>
									</p>
									<p>回传时间：
										<span v-if="rowForm.havePlanTime == 1">开启</span>
										<span v-if="rowForm.havePlanTime == 0">关闭</span>
									</p>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<!-- 腾讯详情 -->
			<table class="el-table el-table--border el-table--enable-row-hover mytable" cellspacing="0" cellpadding="0" v-if="returnPlatform == 2">
				<tbody>
					<tr>
						<td width="200">方案名</td>
						<td>
							<p>{{ rowForm.title }}</p>
						</td>
					</tr>
					<tr>
						<td>回传类型</td>
						<td>
							<span v-if="rowForm.type == 3">免费回传</span>
							<span v-if="rowForm.type == 4">付费回传</span>
						</td>
					</tr>
					<tr>
						<td>投放目标</td>
						<td>
							<span v-if="rowForm.way == 1">关键行为</span>
							<span v-if="rowForm.way == 2">付费</span>
							<span v-if="rowForm.way == 3">注册</span>
						</td>
					</tr>
					<tr v-if="formInline.type == 4">
						<td>回传配置</td>
						<td>
							<span v-if="rowForm.postbakSet == 1">全部回传配置</span>
							<span v-if="rowForm.postbakSet == 2">自定义回传配置</span>
						</td>
					</tr>
					<tr>
						<td>{{ formInline.type == 3 ? '回传条件' : '回传规则' }}</td>
						<td>
							<div v-if="formInline.type == 3">
								<p>条件一：</p>
								<p>注册时间≥{{ rowForm.conditionTime }}秒</p>
								<p>
									<span v-if="rowForm.firstCondition == 1">且</span>
									<span v-if="rowForm.firstCondition == 2">或</span>
								</p>
								<p>条件二：</p>
								<p>
									广告播放次数≥{{ rowForm.adPlay }}次&nbsp;&nbsp;
									<span v-if="rowForm.secondCondition == 1">且</span>
									<span v-if="rowForm.secondCondition == 2">或</span>&nbsp;&nbsp;
									浏览集数≥{{ rowForm.epPlay }}集
								</p>
								<p>回传设置：</p>
								<p>
									<span style="margin-right: 10px;">{{ rowForm.postbakSet == 2 ? '自定义回传' : '全部回传' }}</span>
									<span v-if="rowForm.postbakSet == 2">传{{ rowForm.conveyNumber }}漏{{ rowForm.omitNumber }}</span>
								</p>
							</div>
							<div v-if="formInline.type == 4">
								<p v-if="rowForm.postbakSet == 1">
									<span v-if="rowForm.payBackWay == 1">回传用户所有充值</span>
									<span v-if="rowForm.payBackWay == 2">回传用户当天自然日所有充值</span>
									<span v-if="rowForm.payBackWay == 3">回传用户24小时内所有充值</span>
									<span v-if="rowForm.payBackWay == 4">回传用户首充</span>
									<span v-if="rowForm.payBackWay == 5">回传用户当天自然日首充</span>
									<span v-if="rowForm.payBackWay == 6">回传用户24小时内首充</span>
									<span v-if="rowForm.payBackWay == 7">回传用户在X小时内首次充值金额大于Y后的所有充值（含首次充值）</span>
									<span v-if="rowForm.payBackWay == 8">回传用户在X小时内单笔充值金额大于Y的首充</span>
								</p>
								<div v-if="rowForm.postbakSet == 2">
									<p>回传维度：
										<span v-if="rowForm.havePlan == 0">按链接回传</span>
										<span v-if="rowForm.havePlan == 1">按计划回传</span>
									</p>
									<p>回传保护数：
										<span>{{ rowForm.havePlanNumber }}</span>
									</p>
									<p>回传时间：
										<span v-if="rowForm.havePlanTime == 1">开启</span>
										<span v-if="rowForm.havePlanTime == 0">关闭</span>
									</p>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogInfoVisible = false">确 定</el-button>
			</div>
		</el-dialog>
		<!--修改弹框-巨量-->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="850px">
			<el-form :rules="rules" ref="ruleForm" :model="ruleForm" label-width="150px" size="small" class="input350"
				style="max-height: 600px;overflow: auto; padding-right: 20px;">
				<el-form-item label="方案名称：" prop="title">
					<el-input v-model="ruleForm.title" placeholder="请输入方案名称"></el-input>
				</el-form-item>
				<el-form-item label="回传类型：" prop="type">
					<el-select v-model="ruleForm.type" filterable clearable placeholder="请选择回传类型" @change="changeTypeOptions">
						<el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="回传方式：" prop="way" v-if="returnPlatform != 2">
					<el-tag>{{ ruleForm.type == 2 ? '付费' : '关键行为' }}</el-tag>
					<!-- <el-select v-model="ruleForm.way" filterable clearable placeholder="请选择回传方式">
						<el-option
							v-for="item in wayOptions"
							:key="item.value"
							:label="item.label"
							:value="item.value"
						>
						</el-option>
					</el-select> -->
				</el-form-item>
				<el-form-item label="投放目标：" prop="way" v-if=" (platform == 'wx-sv' && returnPlatform == 2) || (platform == 'wx-gg-sv' && returnPlatform == 2) ">
					<el-select v-model="ruleForm.way" filterable placeholder="请选择投放目标">
						<el-option v-for="item in wayOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="回传状态：" prop="status" v-if=" platform != 'wx-sv' && platform != 'wx-gg-sv' && ruleForm.type != 2 && ruleForm.type != 4 ">
					<el-select v-model="ruleForm.status" filterable clearable placeholder="请选择回传状态">
						<el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="付费金额：" prop="haveMoney" v-if="ruleForm.type == 2 || ruleForm.type == 4">
					<el-radio-group v-model="ruleForm.haveMoney">
						<el-radio :label="0">不回传</el-radio>
						<el-radio :label="1">回传</el-radio>
					</el-radio-group>
				</el-form-item>
				<!-- <el-form-item label="定义老用户回传：" v-if="ruleForm.type == 2">
					<el-radio-group v-model="ruleForm.olduserBack">
						<el-radio :label="0">不定义老用户回传</el-radio>
						<el-radio :label="1">以广告计划维度（染色）</el-radio>
						<el-radio :label="2">以注册时间维度</el-radio>
					</el-radio-group>
					<div class="groupPd12" v-if="ruleForm.olduserBack > 0" style="margin-top: 10px;">
						<label>{{ ruleForm.olduserBack == 1 ? '最近染色时间' : '最近注册时间' }}</label>
						<el-select v-model="ruleForm.oldTimeFlag" filterable clearable placeholder="请选择时间"
							style="width: 130px; margin: 0 10px;">
							<el-option v-for="item in oldTimeFlagOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
						<div v-if="ruleForm.oldTimeFlag == 1" style="display: inline-block ">
							<el-form-item style="display: inline-block" prop="oldTime">
								<el-input placeholder="请输入" v-model="ruleForm.oldTime" min="0" style="width: 130px;">
									<template slot="append">小时</template>
								</el-input>
							</el-form-item>
							<label style="margin-left: 10px;">为老用户</label>
						</div>
					</div>
				</el-form-item> -->
				<div class="inline groupPd12" style="margin-left: -80px;">
					<!-- 免费回传 -->
					<el-form-item v-if="ruleForm.type != 2 && ruleForm.type != 4">
						<p>条件一：</p>
						<el-form-item prop="conditionTime" v-if="platform == 'wx-sv' || platform == 'wx-gg-sv' ">
							<el-input placeholder="请输入时长" v-model="ruleForm.conditionTime" clearable min="0" style="width: 300px">
								<template slot="prepend">
									<el-select v-model="ruleForm.conditionWay" slot="prepend" placeholder="请选择">
										<el-option label="注册时长" :value="1"></el-option>
									</el-select>
								</template>
								<template slot="append">秒</template>
							</el-input>
						</el-form-item>
						<el-form-item prop="adNumber" v-else>
							<el-input placeholder="" v-model="ruleForm.adNumber" clearable min="0" style="width: 300px">
								<template slot="prepend">广告播放次数≥</template>
								<template slot="append">次</template>
							</el-input>
						</el-form-item>
						<p class="relation" v-if="platform=='wx-sv' || platform=='wx-gg-sv'">
							<label>大条件关联：</label>
							<el-radio-group v-model="ruleForm.firstCondition">
								<el-radio :label="1">且</el-radio>
								<el-radio :label="2">或</el-radio>
							</el-radio-group>
						</p>
						<p class="relation" v-else>
							<label>条件关联：</label>
							<el-radio-group v-model="ruleForm.relation">
								<el-radio :label="1">且</el-radio>
								<el-radio :label="2">或</el-radio>
							</el-radio-group>
						</p>
						<el-form-item prop="balance">
							<p>条件二：</p>
							<el-form-item prop="adPlay" v-if="platform == 'wx-sv' || platform=='wx-gg-sv' ">
								<el-input placeholder="" v-model="ruleForm.adPlay" clearable min="0" style="width: 300px">
									<template slot="prepend">广告播放次数≥</template>
									<template slot="append">次</template>
								</el-input>
							</el-form-item>
							<div class="row-inline" v-else>
								<el-select v-model="ruleForm.ecpmType" filterable>
									<el-option v-for="item in ecpmTypeOptions" :key="item.value" :label="item.label" :value="item.value">
									</el-option>
								</el-select>
								<template v-if="ruleForm.ecpmType != 3">
									<el-form-item prop="ecpmNumber">
										<el-input class="one-input" v-model="ruleForm.ecpmNumber" min="0">
											<template slot="prepend" v-if="ruleForm.ecpmType == 1">≥</template>
											<template slot="prepend" v-if="ruleForm.ecpmType == 2">≤</template>
										</el-input>
									</el-form-item>
								</template>
								<template v-if="ruleForm.ecpmType == 3">
									<el-form-item class="prev-input" prop="ecpmNumber" min="0">
										<el-input v-model="ruleForm.ecpmNumber"></el-input>
									</el-form-item>
									<el-form-item class="next-input" prop="ecpmAfterNumber">
										<el-input v-model="ruleForm.ecpmAfterNumber">
											<template slot="prepend">≤</template>
										</el-input>
									</el-form-item>
								</template>
							</div>
							<p class="relation" v-if="platform == 'wx-sv' || platform=='wx-gg-sv' ">
								<label>小条件关联：</label>
								<el-radio-group v-model="ruleForm.secondCondition">
									<el-radio :label="1">且</el-radio>
									<el-radio :label="2">或</el-radio>
								</el-radio-group>
							</p>
							<el-form-item prop="epPlay" v-if="platform == 'wx-sv' || platform=='wx-gg-sv' ">
								<el-input placeholder="" v-model="ruleForm.epPlay" clearable min="0" style="width: 300px">
									<template slot="prepend">浏览集数≥</template>
									<template slot="append">集</template>
								</el-input>
							</el-form-item>
							<div class="row-inline" v-else>
								<el-select v-model="ruleForm.arpuType" filterable>
									<el-option v-for="item in arpuTypeOptions" :key="item.value" :label="item.label" :value="item.value">
									</el-option>
								</el-select>
								<template v-if="ruleForm.arpuType != 3">
									<el-form-item prop="arpuNumber">
										<el-input class="one-input" v-model="ruleForm.arpuNumber" min="0">
											<template slot="prepend" v-if="ruleForm.arpuType == 1">≥</template>
											<template slot="prepend" v-if="ruleForm.arpuType == 2">≤</template>
										</el-input>
									</el-form-item>
								</template>
								<template v-if="ruleForm.arpuType == 3">
									<el-form-item class="prev-input" prop="arpuNumber" min="0">
										<el-input v-model="ruleForm.arpuNumber"></el-input>
									</el-form-item>
									<el-form-item class="next-input" prop="arpuAfterNumber" min="0">
										<el-input v-model="ruleForm.arpuAfterNumber">
											<template slot="prepend">≤</template>
										</el-input>
									</el-form-item>
								</template>
							</div>
						</el-form-item>
						<el-form-item>
							<p>回传设置：</p>
							<div class="row-inline">
								<el-select v-model="ruleForm.postbakSet" filterable>
									<el-option v-for="item in postbakSetOptions" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
								<template v-if="ruleForm.postbakSet == 2">
									<span>传</span>
									<el-form-item prop="conveyNumber">
										<el-input type="number" class="return-input" v-model="ruleForm.conveyNumber" min="1"
											placeholder="请输入回传广告数"></el-input>
									</el-form-item>
									<span>漏</span>
									<el-form-item prop="omitNumber">
										<el-input type="number" class="return-input" v-model="ruleForm.omitNumber" min="1"
											placeholder="请输入不回传广告数"></el-input>
									</el-form-item>
								</template>
							</div>
							<p v-if="ruleForm.postbakSet == 2" style="font-size: 12px; margin-top: -10px;color: #C0C4CC;">
								自定义回传下，符合条件的广告按照回传规则回传，不符合的默认不回传</p>
						</el-form-item>
					</el-form-item>
					<!-- 付费回传 -->
					<el-form-item v-if="ruleForm.type == 2 || ruleForm.type == 4">
						<h4 style="padding: 15px 0; border-top: 1px solid #BBBBBB; color: #101010">回传配置</h4>
						<el-form-item prop="postbakSet">
							<el-radio-group v-model="ruleForm.postbakSet">
								<el-radio :label="1">全部回传配置</el-radio>
								<el-radio :label="2">自定义回传配置</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-form-item>
					<el-form-item v-if="(ruleForm.type == 2 && ruleForm.postbakSet == 1) || (ruleForm.type == 4 && ruleForm.postbakSet == 1)">
						<el-form-item label="" prop="payBackWay">
							<div style="display: flex;">
								<p style="display: inline;margin-top: -9px;margin-left:-28px">回传所有充值：</p>
								<el-radio-group v-model="ruleForm.payBackWay" style="width: 300px;margin-left: 13px">
									<el-radio :label="1">回传用户所有充值</el-radio>
									<el-radio :label="2" style="margin: 10px 0;">回传用户当天自然日所有充值</el-radio>
									<el-radio :label="3">回传用户24小时内所有充值</el-radio>
								</el-radio-group>
							</div>
						</el-form-item>
						<el-form-item prop="payBackWay" lab>
							<div style="display: flex;">
								<p style="display: inline;margin-top: -9px;">回传首充：</p>
								<el-radio-group v-model="ruleForm.payBackWay" style="width: 300px;margin-left: 13px">
									<el-radio :label="4">回传用户首充</el-radio>
									<el-radio :label="5" style="margin: 10px 0;">回传用户当天自然日首充</el-radio>
									<el-radio :label="6">回传用户24小时内首充</el-radio>
								</el-radio-group>
							</div>
						</el-form-item>
						<el-form-item>
							<div style="display: flex;">
								<p style="display: inline;margin-left:-14px">自定义上报：</p>
								<p style="display: flex;margin-left: 15px">
									<el-form-item prop="payBackWayTime">
										<el-input placeholder="小时" v-model="ruleForm.payBackWayTime" clearable min="0" style="width: 150px">
											<template slot="prepend">X=</template>
										</el-input>
									</el-form-item>
									<el-form-item prop="payBackWayMoney">
										<el-input placeholder="金额" v-model="ruleForm.payBackWayMoney" clearable min="0"
											style="width: 150px;margin-left: 15px">
											<template slot="prepend">Y=</template>
										</el-input>
									</el-form-item>
								</p>
							</div>
							<el-form-item prop="payBackWay" style="margin-left: 85px;">
								<el-radio-group v-model="ruleForm.payBackWay">
									<el-radio :label="7" style="margin: 10px 0;">回传用户在X小时内首次充值金额大于Y后的所有充值（含首次充值）</el-radio>
									<el-radio :label="8">回传用户在X小时内单笔充值金额大于Y的首充</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-form-item>
					</el-form-item>
					<el-form-item v-if="(ruleForm.type == 2 && ruleForm.postbakSet == 2) || (ruleForm.type == 4 && ruleForm.postbakSet == 2)" style="margin-left: -36px;">
						<el-form-item label="回传维度：" prop="havePlan">
							<el-checkbox v-model="ruleForm.havePlan">按计划回传</el-checkbox>
						</el-form-item>
						<el-form-item label="回传时间：" prop="havePlanTime">
							<div style="display: flex;">
								<el-switch v-model="ruleForm.havePlanTime" active-color="#13ce66" inactive-color="#ff4949"
									style="margin-top: 5px;">
								</el-switch>
								<el-select v-if="ruleForm.havePlanTime" v-model="ruleForm.havePlanTimeWay" filterable
									style="margin-left: 20px">
									<el-option v-for="item in havePlanTimeWayOptions" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</div>
						</el-form-item>
						<el-form-item label="回传保护：" prop="havePlan">
							<div style="display: flex;">
								<el-form-item prop="havePlanMoney">
									<el-input placeholder="金额" v-model="ruleForm.havePlanMoney" clearable min="0"
										style="width: 150px;margin-right: 15px">
										<template slot="prepend">Y≥</template>
									</el-input>
								</el-form-item>
								<p>保护</p>
								<el-form-item prop="havePlanNumber">
									<el-input placeholder="输入几,前X个用户不卡回传" v-model="ruleForm.havePlanNumber" clearable min="0"
										style="width: 205px;margin-left: 15px"></el-input>
								</el-form-item>
							</div>
						</el-form-item>
						<!-- <el-form-item label="回传规则：" prop="postbackPlan">
							<el-button @click="addpostbackPlanList()">新增</el-button>
						</el-form-item> -->
						<el-form-item label="回传规则：">
							<div class="back-table" style="margin: 40px 20px 0 -90px;">
								<h4>
									<b>最小额（≥）</b>
									<b>最大额（&lt;）</b>
									<b class="way">回传方式</b>
									<b class="percent">回传比例</b>
								</h4>
								<ul>
									<li v-for="(item, index) in ruleForm.postbackPlanList" :key="index">
										<div class="cell">
											<el-input v-if="index == 0" type="number" v-model="item.minMoney" placeholder=""></el-input>
											<el-input v-else type="number" v-model="item.minMoney" placeholder=""
												@blur="blurMin(index, item.minMoney)"></el-input>
											<label style="position: relative; left: 10px;">-</label>
										</div>
										<div class="cell">
											<el-form-item :prop="'postbackPlanList.' + index + '.maxMoney'" :rules="rules.payRules.maxMoney"
												:key="'postbackPlanList.' + index + '.maxMoney'">
												<el-input type="number" v-model="item.maxMoney" @input="inputMax(index, item.maxMoney)"
													@change="changeMax(index, item.maxMoney)" placeholder=""></el-input>
											</el-form-item>
										</div>
										<div class="cell way">
											<el-form-item>
												<el-select v-model="item.postbackType" filterable clearable placeholder="请选择回传方式"
													style="width: 120px;">
													<el-option v-for="item in postbackTypeOptions" :key="item.value" :label="item.label"
														:value="item.value">
													</el-option>
												</el-select>
											</el-form-item>
										</div>
										<div class="cell percent">
											<template v-if="item.postbackType == 1">
												<span style="margin-right: 5px;">传</span>
												<el-form-item :prop="'postbackPlanList.' + index + '.conveyNumber'"
													:rules="rules.payRules.conveyNumber" :key="'postbackPlanList.' + index + '.conveyNumber'">
													<el-input type="number" class="input-number140" v-model="item.conveyNumber"
														min="1"></el-input>
												</el-form-item>
												<span style="margin: 0 8px;">漏</span>
												<el-form-item :prop="'postbackPlanList.' + index + '.omitNumber'"
													:rules="rules.payRules.omitNumber" :key="'postbackPlanList.' + index + '.omitNumber'">
													<el-input type="number" class="input-number140" v-model="item.omitNumber" min="0"></el-input>
												</el-form-item>
											</template>
											<template v-if="item.postbackType == 0">
												<span style="font-size: 13px;">全部回传</span>
											</template>
											<template v-if="item.postbackType == 2">
												<span style="font-size: 13px;">全部不回传</span>
											</template>
										</div>
										<div class="cell btn">
											<!--</template>-->
											<i class="el-icon-circle-plus-outline" @click="addpostbackPlanList(item.maxMoney, index)"></i>
											<i class="el-icon-remove-outline" v-if="ruleForm.postbackPlanList.length > 1"
												@click="delpostbackPlanList(index)"></i>
										</div>
									</li>
								</ul>
								<div class="danger-text">重点：参与过回传的用户不再参与所有规则回传。未在规则内的额度的订单，只传用户第一笔</div>
							</div>
						</el-form-item>
					</el-form-item>
				</div>
				<!--<el-form-item label="clickid" prop="tfId">-->
				<!--<el-input v-model="ruleForm.tfId" placeholder="请输入投放链接ID"></el-input>-->
				<!--</el-form-item>-->
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="editDialogSureBtn('ruleForm')">确 定</el-button>
			</div>
		</el-dialog>
		<agent-pop :visible.sync="isShowDialogAgent"></agent-pop>
	</div>
</template>
<script>
import AgentPop from '@/components/AgentPop'
import { list, add, details, addPay, payList, payDetails, addTx } from "@/api/dysvzk/agentmenu/return";
export default {
	components: {
		AgentPop
	},
	data() {
		var validateNum = (rule, value, callback) => {
			if (value < 0) {
				return callback(new Error('输入的数不能小于0'));
			} else {
				callback();
			}
		};
		var validateOne = (rule, value, callback) => {
			if (value < 1) {
				return callback(new Error('输入的数不能小于1'));
			} else {
				callback();
			}
		};
		var validateOmit = (rule, value, callback) => {
			if (value < 0) {
				return callback(new Error('输入的漏传数不能小于0'));
			} else {
				callback();
			}
		};
		var validateConvey = (rule, value, callback) => {
			if (value <= 0) {
				return callback(new Error('输入的回传数必须大于0'));
			} else {
				callback();
			}
		};
		var validatePlanTime = (rule, value, callback) => {
			if (value == '' || !value) {
				return callback(new Error('请选择回传时间'));
			} else {
				callback();
			}
		};

		return {
			loading: false,
			platform: localStorage.getItem('platform'),
			dataTime: [],
			returnPlatform: 1,
			formInline: {
				title: '',
				type: 1
			},
			tableData: {
				pageSize: 20,
				pageNo: 1,
				totalPage: 1,
				totalNum: 0,
				result: [
				]
			},
			currentPage: 1,
			dialogFormVisible: false,
			typeOptions: [
				{
					value: 1,
					label: '免费回传'
				},
				{
					value: 2,
					label: '付费回传'
				},
			],
			wayOptions: [
				{
					value: 2,
					label: '付费'
				},
				{
					value: 3,
					label: '注册'
				},
			],
			oldTimeFlagOptions: [
				{
					value: 0,
					label: '当天自然日',
				},
				{
					value: 1,
					label: '≥'
				},
			],
			//回传状态
			statusOptions: [
				{
					value: 1,
					label: '广告回传'
				},
				{
					value: 2,
					label: '按人回传'
				}
			],
			ecpmTypeOptions: [
				{
					value: 1,
					label: 'ECPM≥'
				},
				{
					value: 2,
					label: 'ECPM≤'
				},
				{
					value: 3,
					label: '≤ECPM≤'
				}
			],
			arpuTypeOptions: [
				{
					value: 1,
					label: 'ARPU≥'
				},
				{
					value: 2,
					label: 'ARPU≤'
				},
				{
					value: 3,
					label: '≤ARPU≤'
				}
			],
			postbakSetOptions: [
				{
					value: 1,
					label: '全部回传'
				},
				{
					value: 2,
					label: '自定义回传'
				},
			],
			havePlanTimeWayOptions: [
				{
					value: 0,
					label: '当天自然日'
				},
				{
					value: 1,
					label: '24小时'
				},
				{
					value: 2,
					label: '168小时内（7天）'
				},
			],
			postbackTypeOptions: [
				{
					value: 0,
					label: '全部回传'
				},
				{
					value: 1,
					label: '自定义回传'
				},
				{
					value: 2,
					label: '全部不回传'
				},
			],
			rowForm: {},
			dialogInfoVisible: false,
			dialogTitle: '',
			ruleForm: {
				adNumber: '',
				addTime: '',
				agentId: '',
				arpuAfterNumber: '',
				arpuNumber: '',
				arpuType: 1,
				conveyNumber: '',
				ecpmAfterNumber: '',
				ecpmNumber: '',
				ecpmType: 1,
				id: '',
				omitNumber: '',
				postbakSet: 1,
				relation: 1,
				status: 1,
				title: '',
				type: '',
				updateType: "",
				way: 2,
				oldTime: '',
				oldTimeFlag: 0,
				olduserBack: 0,
				haveMoney: 0,
				payBackWay: 2,
				payBackWayTime: '',
				payBackWayMoney: '',
				havePlan: false,
				havePlanTime: false,
				havePlanTimeWay: 0,
				postbackPlanList: [
					{
						conveyNumber: null,
						maxMoney: null,
						minMoney: 0,
						omitNumber: null,
						postbackType: 0
					}
				],
				havePlanMoney: null,
				havePlanNumber: null,
				// 腾讯广告
				conditionWay:1,
				conditionTime:'',
				firstCondition:1,
				adPlay:'',
				secondCondition:1,
				epPlay:''
			},
			rules: {
				title: [
					{ required: true, message: '请输入方案名称', trigger: 'blur' }
				],
				type: [
					{ required: true, message: '请选择回传类型', trigger: 'change' }
				],
				way: [
					{ required: true, message: '请选择回传方式', trigger: 'change' }
				],
				status: [
					{ required: true, message: '请选择回传状态', trigger: 'change' }
				],
				adNumber: [
					{ required: true, message: '请输入广告播放次数', trigger: 'blur' },
					{ validator: validateNum, trigger: 'blur' }
				],
				ecpmNumber: [
					{ required: true, message: '请输入ECPM值', trigger: 'blur' },
					{ validator: validateNum, trigger: 'blur' }
				],
				ecpmAfterNumber: [
					{ required: true, message: '请输入ECPM最大值', trigger: 'blur' },
					{ validator: validateNum, trigger: 'blur' }
				],
				arpuNumber: [
					{ required: true, message: '请输入ARPU值', trigger: 'blur' },
					{ validator: validateNum, trigger: 'blur' }
				],
				arpuAfterNumber: [
					{ required: true, message: '请输入ARPU最大值', trigger: 'blur' },
					{ validator: validateNum, trigger: 'blur' }
				],
				conveyNumber: [
					{ required: true, message: '请输入回传广告数', trigger: 'blur' },
					{ validator: validateOne, trigger: 'blur' }
				],
				omitNumber: [
					{ required: true, message: '请输入不回传广告数', trigger: 'blur' },
					{ validator: validateOne, trigger: 'blur' }
				],
				payRules: {
					postbackType: [
						{ required: true, message: '请选择回传方式', trigger: 'change' }
					],
					minMoney: [
						{ required: true, message: '最小金额', trigger: 'blur' },
					],
					maxMoney: [{ required: true, message: '最大金额', trigger: 'blur' }],
					omitNumber: [
						{ required: true, message: '漏传数', trigger: 'blur' },
						{ validator: validateOmit, trigger: 'blur' }
					],
					conveyNumber: [
						{ required: true, message: '回传数', trigger: 'blur' },
						{ validator: validateConvey, trigger: 'blur' }
					],
				},
				havePlanTime: [
					{ required: true, message: '请选择回传时间', trigger: 'change' },
				],
				havePlanTimeWay: [
					{ validator: validatePlanTime, trigger: 'change' }
				]
			},
			isShowDialogAgent: true,
		}
	},
	computed: {},
	watch: {
	},
	created() {
		if (JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId) {
			this.isShowDialogAgent = false
		} else {
			this.isShowDialogAgent = true
		}
	},
	mounted: function () {
		if ( (this.platform == 'wx-sv' && this.returnPlatform == 1) || (this.platform == 'wx-gg-sv' && this.returnPlatform == 1) ) {
			this.formInline.type = 2
			this.typeOptions = [
				{
					value: 2,
					label: '付费回传'
				},
			]
		}
		this.getTableData()
	},
	methods: {
		search () {
			this.currentPage = 1
			this.getTableData()
		},
		resetQuery: function () {
			this.$refs['formInline'].resetFields()
			this.dataTime = []
			this.getTableData()
		},
		// pageSize切换
		handleSizeChange(val) {
			this.tableData.pageSize = val
			this.currentPage = 1
			this.getTableData()
		},
		handleCurrentChange(value) {
			this.currentPage = value
			this.getTableData()
		},
		addData() {
			this.dialogFormVisible = true
			console.log("this.$refs['ruleForm']", this.$refs['ruleForm'] !== undefined)
			if (this.$refs['ruleForm'] !== undefined) {
				this.$refs['ruleForm'].resetFields()
			}
			this.dialogTitle = '添加回传方案'
			this.ruleForm = {
				adNumber: '',
				addTime: '',
				agentId: '',
				arpuAfterNumber: '',
				arpuNumber: '',
				arpuType: 1,
				conveyNumber: '',
				ecpmAfterNumber: '',
				ecpmNumber: '',
				ecpmType: 1,
				id: '',
				omitNumber: '',
				postbakSet: 1,
				relation: 1,
				status: 1,
				title: '',
				type: this.formInline.type,
				updateType: 'add',
				way: 2,
				oldTime: '',
				oldTimeFlag: 0,
				olduserBack: 0,
				haveMoney: 0,
				payBackWay: 2,
				payBackWayTime: '',
				payBackWayMoney: '',
				havePlan: false,
				havePlanTime: false,
				havePlanTimeWay: 0,
				postbackPlanList: [
					{
						conveyNumber: null,
						maxMoney: null,
						minMoney: 0,
						omitNumber: null,
						postbackType: 0
					}
				],
				havePlanMoney: null,
				havePlanNumber: null,
				// 腾讯广告
				conditionWay:1,
				conditionTime:'',
				firstCondition:1,
				adPlay:'',
				secondCondition:1,
				epPlay:''
			}

		},
		handleLook(id) {
			this.dialogInfoVisible = true
			if( (this.platform == 'wx-sv' && this.returnPlatform == 2) || (this.platform == 'wx-gg-sv' && this.returnPlatform == 2) ){
				this.getDetailsTx(id,'look')
			}else{
				this.getDetails(id, 'look')
			}
		},
		// 编辑
		handleEdit(id) {
			this.dialogTitle = '编辑'
			this.dialogFormVisible = true
			console.log(id,this.$refs['ruleForm'])
			// if (this.$refs['ruleForm'] !== undefined) {
			//     this.$refs['ruleForm'].resetFields()
			// }
			if((this.platform == 'wx-sv' && this.returnPlatform == 2) || (this.platform == 'wx-gg-sv' && this.returnPlatform == 2) ){
				this.getDetailsTx(id,'edit')
			}else{
				this.getDetails(id, 'edit')
			}
		},
		// 获取详情
		getDetails(id, text) {
			if (this.formInline.type == 2) {
				payDetails({
					infoId: id,
				}).then(response => {
					if (response.data.head.flag === 0) {
						this.rowForm = response.data.content
						this.ruleForm = response.data.content
						if (text == 'edit') {
							this.ruleForm.updateType = 'edit'
							this.ruleForm.addTime = ''
							this.ruleForm.updTime = ''
							this.ruleForm.havePlan = this.ruleForm.havePlan == 1 ? true : false
							this.ruleForm.havePlanTime = this.ruleForm.havePlanTime == 1 ? true : false
							if (this.ruleForm.postbackPlanList.length == 0) {
								this.ruleForm.postbackPlanList = [
									{
										conveyNumber: null,
										maxMoney: null,
										minMoney: 0,
										omitNumber: null,
										postbackType: 0
									}
								]
							}

						}
						if (this.$refs['ruleForm'] !== undefined) {
							this.$refs['ruleForm'].resetFields()
						}
					} else {
						this.$message.error(response.data.head.desc);
					}
				})
			} else {
				details({
					infoId: id,
				}).then(response => {
					if (response.data.head.flag === 0) {
						this.rowForm = response.data.content
						this.ruleForm = response.data.content
						if (text == 'edit') {
							this.ruleForm.updateType = 'edit'
							this.ruleForm.addTime = ''
							this.ruleForm.updTime = ''
						}
						if (this.$refs['ruleForm'] !== undefined) {
							this.$refs['ruleForm'].resetFields()
						}
					} else {
						this.$message.error(response.data.head.desc);
					}
				})
			}

		},
		// 获取详情-腾讯
		getDetailsTx(id,text) {
			if (this.formInline.type == 4) {
				console.log("获取详情付费-腾讯 ",id)
				this.wayOptions = [
					{
						value: 2,
						label: '付费'
					},
				]
				payDetails({
					infoId: id,
				}).then(response => {
					if (response.data.head.flag === 0) {
						this.rowForm = response.data.content
						this.ruleForm = response.data.content
						if (text == 'edit') {
							this.ruleForm.updateType = 'edit'
							this.ruleForm.addTime = ''
							this.ruleForm.updTime = ''
							this.ruleForm.havePlan = this.ruleForm.havePlan == 1 ? true : false
							this.ruleForm.havePlanTime = this.ruleForm.havePlanTime == 1 ? true : false
							if (this.ruleForm.postbackPlanList.length == 0) {
								this.ruleForm.postbackPlanList = [
									{
										conveyNumber: null,
										maxMoney: null,
										minMoney: 0,
										omitNumber: null,
										postbackType: 0
									}
								]
							}

						}
						if (this.$refs['ruleForm'] !== undefined) {
							this.$refs['ruleForm'].resetFields()
						}
					} else {
						this.$message.error(response.data.head.desc);
					}
				})
			} else {
				console.log("获取详情付费-免费 ",id)
				this.wayOptions = [
					{
						value: 3,
						label: '注册'
					},
				]
				this.axios({
					method: 'get',
					url: '/video/VideoPostbackTxTx/details',
					params: {
						infoId:id
					}
				}).then((response) => {
					if (response.data.head.flag === 0) {
						this.rowForm = response.data.content
						this.ruleForm = response.data.content
					} else {
						this.$message.error(response.data.head.desc)
					}
				})

			}

		},
		// 弹框确定
		editDialogSureBtn(formName) {
			console.log("弹窗确定---", this.ruleForm)
			this.$refs[formName].validate((valid) => {
				if (valid) {
					console.log(this.ruleForm.updateType)
					if (this.ruleForm.ecpmType == 3 && this.ruleForm.ecpmAfterNumber < this.ruleForm.ecpmNumber) {
						this.$message.error('ECPM区间不正确')
					} else if (this.ruleForm.arpuType == 3 && this.ruleForm.arpuAfterNumber < this.ruleForm.arpuNumber) {
						this.$message.error('ARPU区间不正确')
					} else {
						if( (this.platform == 'wx-sv' && this.returnPlatform == 2) || (this.platform == 'wx-gg-sv' && this.returnPlatform == 2) ){
							this.saveTableDataTx()
						}else{
							this.saveTableData()
						}
					}
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 保存巨量编辑信息
		saveTableData() {
			console.log("保存---", this.ruleForm)
			if (this.ruleForm.type == 1) {
				const formInfo = {
					adNumber: this.ruleForm.adNumber,
					addTime: this.ruleForm.addTime,
					agentId: this.ruleForm.agentId,
					arpuAfterNumber: this.ruleForm.arpuAfterNumber,
					arpuNumber: this.ruleForm.arpuNumber,
					arpuType: this.ruleForm.arpuType,
					conveyNumber: this.ruleForm.conveyNumber,
					ecpmAfterNumber: this.ruleForm.ecpmAfterNumber,
					ecpmNumber: this.ruleForm.ecpmNumber,
					ecpmType: this.ruleForm.ecpmType,
					id: this.ruleForm.id,
					omitNumber: this.ruleForm.omitNumber,
					postbakSet: this.ruleForm.postbakSet,
					relation: this.ruleForm.relation,
					status: this.ruleForm.status,
					title: this.ruleForm.title,
					type: this.ruleForm.type,
					updateType: this.ruleForm.updateType,
					way: this.ruleForm.way,
				}
				add(formInfo).then(response => {
					if (response.data.head.flag === 0) {
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.getTableData()
						this.dialogFormVisible = false
					} else {
						this.$message.error(response.data.head.desc);
					}
				})
			} else {
				const formInfo = {
					addTime: this.ruleForm.addTime,
					agentId: this.ruleForm.agentId,
					oldTime: this.ruleForm.oldTime,
					oldTimeFlag: this.ruleForm.oldTimeFlag,
					olduserBack: this.ruleForm.olduserBack,
					haveMoney: this.ruleForm.haveMoney,
					havePlan: this.ruleForm.havePlan ? 1 : 0,
					havePlanMoney: this.ruleForm.havePlanMoney,
					havePlanNumber: this.ruleForm.havePlanNumber,
					havePlanTime: this.ruleForm.havePlanTime ? 1 : 0,
					havePlanTimeWay: this.ruleForm.havePlanTimeWay,
					id: this.ruleForm.id,
					payBackWay: this.ruleForm.payBackWay,
					payBackWayMoney: this.ruleForm.payBackWayMoney,
					payBackWayTime: this.ruleForm.payBackWayTime,
					postbackPlanList: this.ruleForm.postbackPlanList,
					postbakSet: this.ruleForm.postbakSet,
					title: this.ruleForm.title,
					type: this.ruleForm.type,
					updateType: this.ruleForm.updateType,
					way: this.ruleForm.way,
				}
				addPay(formInfo).then(response => {
					if (response.data.head.flag === 0) {
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.formInline.type = 2
						this.getTableData()
						this.dialogFormVisible = false
					} else {
						this.$message.error(response.data.head.desc);
					}
				})
			}

		},
		// 保存腾讯编辑信息
		saveTableDataTx() {
			if (this.ruleForm.type == 4) {
				const formInfo = {
					addTime: this.ruleForm.addTime,
					agentId: this.ruleForm.agentId,
					oldTime: this.ruleForm.oldTime,
					oldTimeFlag: this.ruleForm.oldTimeFlag,
					olduserBack: this.ruleForm.olduserBack,
					haveMoney: this.ruleForm.haveMoney,
					havePlan: this.ruleForm.havePlan ? 1 : 0,
					havePlanMoney: this.ruleForm.havePlanMoney,
					havePlanNumber: this.ruleForm.havePlanNumber,
					havePlanTime: this.ruleForm.havePlanTime ? 1 : 0,
					havePlanTimeWay: this.ruleForm.havePlanTimeWay,
					id: this.ruleForm.id,
					payBackWay: this.ruleForm.payBackWay,
					payBackWayMoney: this.ruleForm.payBackWayMoney,
					payBackWayTime: this.ruleForm.payBackWayTime,
					postbackPlanList: this.ruleForm.postbackPlanList,
					postbakSet: this.ruleForm.postbakSet,
					title: this.ruleForm.title,
					type: this.ruleForm.type,
					updateType: this.ruleForm.updateType,
					way: this.ruleForm.way,
				}
				addPay(formInfo).then(response => {
					if (response.data.head.flag === 0) {
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.formInline.type = 4
						this.getTableData()
						this.dialogFormVisible = false
					} else {
						this.$message.error(response.data.head.desc);
					}
				})
				console.log("腾讯付费保存---",formInfo)

			} else {
				const paramJson = {
					adPlay: this.ruleForm.adPlay,
					addtime: this.ruleForm.addTime,
					agentId: this.ruleForm.agentId,
					conditionWay: this.ruleForm.conditionWay,
					conditionTime: this.ruleForm.conditionTime,
					epPlay: this.ruleForm.epPlay,
					firstCondition: this.ruleForm.firstCondition,
					id: this.ruleForm.id,
					conveyNumber:this.ruleForm.conveyNumber,
					omitNumber: this.ruleForm.omitNumber,
					postbakSet: this.ruleForm.postbakSet,
					secondCondition: this.ruleForm.secondCondition,
					title: this.ruleForm.title,
					type: this.ruleForm.type,
					way: this.ruleForm.way,
				}
				addTx(paramJson).then(response => {
					if (response.data.head.flag === 0) {
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.getTableData()
						this.dialogFormVisible = false
					} else {
						this.$message.error(response.data.head.desc);
					}
				})
			}
		},
		getTableData() {
			let json2 = {
				pageNo: this.currentPage,
				pageSize: this.tableData.pageSize
			};
			let json1 = this.formInline;
			let paramJson = { ...json1, ...json2 };
			if ( (this.platform == 'wx-sv' && this.returnPlatform == 2) || (this.platform == 'wx-gg-sv' && this.returnPlatform == 2) ) {
				if(this.formInline.type == 4){
					payList(paramJson).then(response => {
						if (response.data.head.flag === 0) {
							this.tableData = response.data.content
						} else {
							this.$message.error(response.data.head.desc)
						}
					})
				}else{
					this.axios({
						method: 'get',
						url: '/video/VideoPostbackTxTx/getList',
						params: paramJson
					}).then((response) => {
						if (response.data.head.flag === 0) {
							this.tableData = response.data.content
							// this.loading = false
						} else {
							this.$message.error(response.data.head.desc)
						}
					})
				}
				
			} else {
				if (this.formInline.type == 2) {
					payList(paramJson).then(response => {
						if (response.data.head.flag === 0) {
							this.tableData = response.data.content
						} else {
							this.$message.error(response.data.head.desc)
						}
					})
				} else {
					list(paramJson).then(response => {
						if (response.data.head.flag === 0) {
							this.tableData = response.data.content
						} else {
							this.$message.error(response.data.head.desc)
						}
					});
				}
			}

		},
		// 付费自定义回传- 添加
		addpostbackPlanList(max, index) {
			console.log("付费自定义回传- 添加", max)
			// if (this.ruleForm.partReturnData[index].minTopUpAmount > this.ruleForm.partReturnData[index].maxTopUpAmount){
			//     this.$message.error('设置的金额区间不连续')
			// } else {
			this.ruleForm.postbackPlanList.push({
				minMoney: index == this.ruleForm.postbackPlanList.length - 1 ? max : '',
				maxMoney: null,
				conveyNumber: null,
				omitNumber: null,
				postbackType: 0
			})
			// }
		},
		// 付费自定义回传- 删除
		delpostbackPlanList(index) {
			console.log(this.ruleForm.postbackPlanList.length)
			if (index == 0) {
				this.ruleForm.postbackPlanList[index + 1].minMoney = 1
			} else if (index < this.ruleForm.postbackPlanList.length - 1) {
				console.log(this.ruleForm.postbackPlanList[index + 1].minMoney)
				this.ruleForm.postbackPlanList[index + 1].minMoney = this.ruleForm.postbackPlanList[index - 1].maxMoney
			}
			this.ruleForm.postbackPlanList.splice(index, 1)
		},
		// 付费自定义回传- 值改变
		inputMax(index, val) {
			if (index < this.ruleForm.postbackPlanList.length - 1) {
				this.ruleForm.postbackPlanList[index + 1].minMoney = val
			}
		},
		// 付费自定义回传- 值改变
		changeMax(index, val) {
			console.log(index, this.ruleForm.postbackPlanList[index].minMoney, this.ruleForm.postbackPlanList[index].maxMoney)
			if (index < this.ruleForm.postbackPlanList.length - 1) {
				this.ruleForm.postbackPlanList[index + 1].minMoney = val
			}
			if (Number(this.ruleForm.postbackPlanList[index].minMoney) > Number(this.ruleForm.postbackPlanList[index].maxMoney)) {
				this.$message.error('设置的金额区间不连续')
			}
		},
		//输入最大额
		blurMin(index, val) {
			if (Number(val) < Number(this.ruleForm.postbackPlanList[index - 1].maxMoney)) {
				this.$message.error('最小金额需要大于上一个的最大金额')
				this.ruleForm.postbackPlanList[index].minMoney = this.ruleForm.postbackPlanList[index - 1].maxMoney
			}
		},
		//取消编辑弹窗
		// cancelDialog(){
		// 	this.dialogFormVisible = false;
		// }

		//改变回传类型
		changeTypeOptions(value) {
			console.log("回传类型",value)
			this.ruleForm.way = 2
			if((this.platform == 'wx-sv' && this.returnPlatform == 2) || (this.platform == 'wx-gg-sv' && this.returnPlatform == 2)){
				if(value == 2 || value == 4){
					this.wayOptions = [
						// {
						// 	value: 1,
						// 	label: '关键行为',
						// },
						{
							value: 2,
							label: '付费'
						},
						// {
						// 	value: 3,
						// 	label: '注册'
						// },
					]
				}else{
					this.ruleForm.way = 3
					this.wayOptions = [
						{
							value: 3,
							label: '注册'
						},
					]
				}
			}

		},
		// 选择回传平台
		handleReturnPlatform(val) {
			if ((this.platform == 'wx-sv' && val == 2) || (this.platform == 'wx-gg-sv' && val == 2) ) {
				this.formInline.type = 4
				this.typeOptions = [
					{
						value: 3,
						label: '免费回传'
					},
					{
						value: 4,
						label: '付费回传'
					},
				]
			} else {
				this.formInline.type = 2
				this.typeOptions = [
					{
						value: 2,
						label: '付费回传'
					},
				]
			}
			this.getTableData()
		},
		// 巨量回传类型改变
		handleReturnType(type){
			this.formInline.type = type
			this.getTableData()
		},
		
	}
}
</script>
<style lang="scss" scoped>
.return-platform {
	margin-left: 30px;
}

.el-input-group__prepend {
	color: #606266;
}

.relation {
	margin: 0 0 16px 0;
}

.back-table {
	margin: 0px 0 5px;
	padding: 15px;
	background: #fbfbfb;

	h4 {
		color: #101010;
		display: table;

		b {
			display: table-cell;
			width: 100px;
			text-align: center;
			padding: 5px 0;
		}

		b.way {
			width: 150px;
			text-align: center;
		}

		b.percent {
			width: 200px;
		}
	}

	ul li {
		.cell {
			display: inline-block;
			text-align: center;
			width: 100px;

			.el-input {
				width: 70px;
			}
		}

		.cell.way {
			width: 150px;

			.el-select .el-input {
				width: 120px;
			}
		}

		.cell.btn {
			width: 60px;
			text-align: left;
		}

		.cell.percent {
			width: 200px;

			.input-number140 {
				width: 60px;

				.el-input {
					width: auto;
				}
			}
		}

		.el-form-item {
			display: inline-block;
		}

		/*.input-number{*/
		/*width: 100px;*/
		/*.el-input{*/
		/*width: auto;*/
		/*}*/
		/*}*/

	}

	ul li:last-of-type {
		margin-bottom: 0px;
	}

	ul li .cell>i {
		margin-left: 10px;
		cursor: pointer;
	}

	label {
		margin: 0 10px;
	}

	/*.el-select {*/
	/*margin: 0 0px 0 30px;*/
	/*}*/
}
</style>
